import React, { useEffect } from "react";
import MarketCastLogo from "../../Assets/Images/MarketCast_Logo_Color.png";
import SBLogo from "../../Assets/Images/SkillsBridge_Color_Logo.png";
import SBSquareLogo from "../../Assets/Images/SkillsBridge_Square_Color_Logo.png";
import "./SSOLogin.scss";
import { OktaButtonStyled } from "./SSOLogin.styles";
import { API_ENDPOINTS, SSO_LOGIN_DOMAINS } from "config/ApiConfig";

const SSOLogin = () => {
  const handleOktaLogin = () => {
    const host = window.location.hostname.toLowerCase();

    if (host?.includes(SSO_LOGIN_DOMAINS?.toLowerCase())) {
      window.location.href =
        process.env.REACT_APP_SSO_LOGIN_URL ||
        API_ENDPOINTS.SSO_LOGIN;
    } else {
      console.log("Not a MarketCast host, staying on page");
    }
  };

  return (
    <div className="marketcast-bg">
      <div className="marketcast-card">
        <OktaButtonStyled buttonType="secondary" onClick={handleOktaLogin}>
          <img
            src={SBSquareLogo}
            alt="SkillsBridge Square Logo"
            className="sb-square-logo"
          />
          Continue with Okta
        </OktaButtonStyled>
        <div className="marketcast-logos">
          <img
            src={MarketCastLogo}
            alt="MarketCast Logo"
            className="marketcast-logo"
          />
          <img src={SBLogo} alt="SkillsBridge Logo" className="sb-logo" />
        </div>
      </div>
    </div>
  );
};

export default SSOLogin;
